const DEVELOPMENTAL_LEVELS = [
  { level: 1, minAge: 0, maxAge: 2, description: "0-2 years" },
  { level: 2, minAge: 3, maxAge: 3, description: "3 years" },
  { level: 3, minAge: 4, maxAge: 4, description: "4 years" },
  { level: 4, minAge: 5, maxAge: 5, description: "5 years" },
  { level: 5, minAge: 6, maxAge: 6, description: "6 years" },
  { level: 6, minAge: 7, maxAge: 7, description: "7 years" },
  { level: 7, minAge: 8, maxAge: 8, description: "8 years" },
  { level: 8, minAge: 9, maxAge: 12, description: "9-12 years" },
  { level: 9, minAge: 13, maxAge: 18, description: "13-18 years" },
  { level: 10, minAge: 19, maxAge: 999, description: "19+ years" },
];

const FUNCTIONAL_GOAL_LEVEL = 10;

/** Assessment chart sections whose progress level column is Level (F) — goal is 10. */
const FUNCTIONAL_LEVEL_SECTIONS = new Set([
  "Primitive Reflexes",
  "Primitive Reflex Simulation",
  "Interactive Metronome",
  "Vestibular Assessment",
  "Vestibular Exercises",
  "MetroTimer",
  "Smells",
  "Olfactory",
  "Core Exercises",
]);

/**
 * Stim report section keys that use Level (F) in stim HTML forms — goal is 10.
 * Level (D) sections and primitive reflexes in stim reports use age-based goal.
 */
const STIM_FUNCTIONAL_SECTION_KEYS = new Set([
  "olfactory",
  "vestibular",
  "metroTimer",
  "interactiveMetronome",
]);

function getAgeFromDOB(dob) {
  if (!dob) {
    return 0;
  }
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

function getCurrentDevelopmentalLevel(dob) {
  const age = getAgeFromDOB(dob);
  const level = DEVELOPMENTAL_LEVELS.find(
    (entry) => age >= entry.minAge && age <= entry.maxAge
  );
  return level || DEVELOPMENTAL_LEVELS[DEVELOPMENTAL_LEVELS.length - 1];
}

function getDevelopmentalGoalLevel(dob) {
  const currentLevel = getCurrentDevelopmentalLevel(dob);
  return Math.min(currentLevel.level + 1, 10);
}

/** Developmental goal from patient age when DOB is unavailable. */
function getDevelopmentalGoalLevelFromAge(age) {
  const numericAge = Number(age);
  if (Number.isNaN(numericAge)) {
    return FUNCTIONAL_GOAL_LEVEL;
  }
  const currentLevel =
    DEVELOPMENTAL_LEVELS.find(
      (entry) => numericAge >= entry.minAge && numericAge <= entry.maxAge
    ) || DEVELOPMENTAL_LEVELS[DEVELOPMENTAL_LEVELS.length - 1];
  return Math.min(currentLevel.level + 1, 10);
}

function isFunctionalLevelSection(sectionName) {
  if (!sectionName) {
    return false;
  }
  return FUNCTIONAL_LEVEL_SECTIONS.has(sectionName);
}

/** Goal level for a stim report section (Level F → 10; Level D → age; primitive reflexes → age). */
function getStimSectionGoalLevel(sectionKey, dob) {
  if (STIM_FUNCTIONAL_SECTION_KEYS.has(sectionKey)) {
    return FUNCTIONAL_GOAL_LEVEL;
  }
  if (dob) {
    return getDevelopmentalGoalLevel(dob);
  }
  return FUNCTIONAL_GOAL_LEVEL;
}

function getProgressChartGoalLevel(sectionName, dob) {
  if (isFunctionalLevelSection(sectionName)) {
    return FUNCTIONAL_GOAL_LEVEL;
  }
  return getDevelopmentalGoalLevel(dob);
}

export {
  DEVELOPMENTAL_LEVELS,
  FUNCTIONAL_GOAL_LEVEL,
  STIM_FUNCTIONAL_SECTION_KEYS,
  getAgeFromDOB,
  getCurrentDevelopmentalLevel,
  getDevelopmentalGoalLevel,
  getDevelopmentalGoalLevelFromAge,
  isFunctionalLevelSection,
  getStimSectionGoalLevel,
  getProgressChartGoalLevel,
};

export default getProgressChartGoalLevel;
